import styled from 'styled-components';

export const StyledSection = styled.div`
  margin-bottom: 3rem;
`;
